module.exports = function() {
  return new Worker(__webpack_public_path__ + "ae4baf860b36a4fbbc7b.worker.js");
};